import React from "react";
import { useLoadScript } from "@react-google-maps/api";
import classes from "./Maps.module.css";
import Places from "./Places";
import MapView from "./MapView";

const defaultLocation = { lat: 32.715736, lng: -117.161087 };

// type = 'map' || 'places'
const Maps = ({
  type = "map",
  className,
  mapClass,
  placeClass,
  setCoordinates,
  setAddress,
  setPlaceDetail,
  location,
  placeholder,
  label,
  data,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAWauq11iRRPxydTOEpQIklPosjWe7pfmY",
    libraries: ["places"],
  });
  if (!isLoaded) {
    return <div className={classes?.loadingContainer}>Loading</div>;
  }

  if (loadError) {
    return (
      <div className={classes?.ErrorContainer}>
        <span>Map cannot be loaded right now, sorry. </span>
      </div>
    );
  }

  return (
    <div className={`${classes.Container} ${className ? className : ""}`}>
      {type === "map" ? (
        <MapView data={data} location={location} className={mapClass} />
      ) : (
        <Places
          setCoordinates={setCoordinates}
          setAddress={setAddress}
          className={placeClass}
          placeholder={placeholder}
          setPlaceDetail={setPlaceDetail}
          label={label}
        />
      )}
    </div>
  );
};

export default Maps;
